// Zeigt die übernommenen Loox-Texte unter #bewertungen. Die Leiste selbst kommt aus Liquid.
function text(el, wert) {
  el.textContent = wert;
}

function eintrag(karte) {
  const li = document.createElement('li');
  li.className = 'gm-bewertungen__karte';
  const kopf = document.createElement('p');
  kopf.className = 'gm-bewertungen__kopf';
  const sterne = document.createElement('span');
  sterne.className = 'gm-bewertungen__sterne';
  sterne.setAttribute('aria-label', `${karte.sterne} von 5 Sternen`);
  text(sterne, `${'★'.repeat(karte.sterne)}${'☆'.repeat(Math.max(0, 5 - karte.sterne))}`);
  const name = document.createElement('span');
  text(name, karte.name || '');
  kopf.append(sterne, name);
  if (karte.kauf) {
    const kauf = document.createElement('span');
    kauf.className = 'gm-bewertungen__kauf';
    text(kauf, 'Verifizierter Kauf');
    kopf.append(kauf);
  }
  li.append(kopf);
  if (karte.text) {
    const absatz = document.createElement('p');
    absatz.className = 'gm-bewertungen__text';
    text(absatz, karte.text);
    li.append(absatz);
  }
  return li;
}

async function fuellen(wurzel) {
  const seite = wurzel.querySelector ? wurzel : document;
  const block = seite.querySelector('[data-gm-bewertungen]');
  if (!block || block.dataset.gmBewertungenAn === '1') return;
  block.dataset.gmBewertungenAn = '1';
  const liste = block.querySelector('[data-gm-bewertungen-liste]');
  if (!liste || !block.dataset.quelle) return;
  try {
    const daten = await (await fetch(block.dataset.quelle)).json();
    const karten = daten[block.dataset.id] || [];
    if (!karten.length) return;
    const frag = document.createDocumentFragment();
    karten.forEach((karte) => frag.append(eintrag(karte)));
    liste.replaceChildren(frag);
    block.hidden = false;
  } catch {
    block.dataset.gmBewertungenAn = '';
  }
}

if (typeof document !== 'undefined') {
  const start = () => fuellen(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (ereignis) => {
    const block = ereignis.target?.querySelector?.('[data-gm-bewertungen]');
    if (block) delete block.dataset.gmBewertungenAn;
    fuellen(ereignis.target);
  });
}
